import {
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { UserAccount } from '../user-account';
import { AccountService } from '../account-service.service';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-personal-data-form',
  standalone: true,
  imports: [
    MatExpansionModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatSelectModule,
    MatCheckboxModule,
    FormsModule,
    TranslateModule,
  ],
  template: `
    <div>
      <mat-form-field>
        <mat-label>{{ 'personal-data-form.FIRST_NAME' | translate }}</mat-label>
        <input matInput [(ngModel)]="userAccount.name" name="firstName" />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{ 'personal-data-form.LAST_NAME' | translate }}</mat-label>
        <input matInput [(ngModel)]="userAccount.last_name" name="lastName" />
      </mat-form-field>
    </div>
    <!-- <div>
      <mat-form-field>
        <mat-label>{{
          'personal-data-form.LATIN_FIRST_NAME' | translate
        }}</mat-label>
        <input matInput [(ngModel)]="userAccount.latin_name" name="latinName" />
      </mat-form-field>
    </div> -->
    <!-- <div>
      <mat-form-field>
        <mat-label>{{
          'personal-data-form.LATIN_LAST_NAME' | translate
        }}</mat-label>
        <input
          matInput
          [(ngModel)]="userAccount.latin_lastname"
          name="latinLastName"
        />
      </mat-form-field>
    </div> -->
    <div>
      <mat-form-field>
        <mat-label>{{ 'personal-data-form.BIRTHDATE' | translate }}</mat-label>
        <input
          matInput
          [matDatepicker]="picker"
          [(ngModel)]="userAccount.birthdate"
          name="birthdate"
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{ 'personal-data-form.COUNTRY' | translate }}</mat-label>
        <input matInput [(ngModel)]="userAccount.country" name="country" />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{ 'personal-data-form.CITY' | translate }}</mat-label>
        <input matInput [(ngModel)]="userAccount.city" name="city" />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{
          'personal-data-form.MOBILE_NUMBER' | translate
        }}</mat-label>
        <input
          matInput
          [(ngModel)]="userAccount.mobile_number"
          name="mobileNumber"
          type="tel"
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{
          'personal-data-form.NATIONALITY' | translate
        }}</mat-label>
        <input
          matInput
          [(ngModel)]="userAccount.nationality"
          name="nationality"
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{ 'personal-data-form.GENDER' | translate }}</mat-label>
        <mat-select [(ngModel)]="userAccount.gender" name="gender">
          <mat-option [value]="1">{{
            'personal-data-form.GENDER_MALE' | translate
          }}</mat-option>
          <mat-option [value]="2">{{
            'personal-data-form.GENDER_FEMALE' | translate
          }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div>
      <mat-checkbox
        [(ngModel)]="userAccount.is_activated"
        name="isActivated"
        [disabled]="true"
      >
        {{ 'personal-data-form.IS_ACTIVATED' | translate }}
      </mat-checkbox>
    </div>
    <div>
      <mat-checkbox
        [(ngModel)]="userAccount.is_premium"
        name="isPremium"
        [disabled]="true"
      >
        {{ 'personal-data-form.IS_PREMIUM' | translate }}
      </mat-checkbox>
    </div>
    <!-- <div>
      <mat-checkbox
        [(ngModel)]="userAccount.is_verified"
        name="isVerified"
        [disabled]="true"
      >
        {{ 'personal-data-form.IS_VERIFIED' | translate }}
      </mat-checkbox>
    </div> -->
    <div>
      <mat-checkbox
        [(ngModel)]="userAccount.profile_completed"
        name="profileCompleted"
        [disabled]="true"
      >
        {{ 'personal-data-form.PROFILE_COMPLETED' | translate }}
      </mat-checkbox>
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{ 'personal-data-form.LAST_LOGIN' | translate }}</mat-label>
        <input
          matInput
          [(ngModel)]="userAccount.last_login"
          name="lastLogin"
          disabled
        />
      </mat-form-field>
    </div>
    <div>
      <button mat-button (click)="savePersonalData()">
        {{ 'personal-data-form.SAVE_BUTTON' | translate }}
      </button>
    </div>
    <div>
      <button mat-button (click)="logout()">
        {{ 'personal-data-form.LOGOUT_BUTTON' | translate }}
      </button>
    </div>
  `,
  styleUrls: ['./personal-data-form.component.css'],
})
export class PersonalDataFormComponent {
  @Input() userAccount!: UserAccount;
  @Output() save = new EventEmitter<void>();

  constructor(
    private accountService: AccountService,
    private router: Router,
  ) {}

  savePersonalData() {
    this.accountService.run(this.userAccount, 'updateAccount').subscribe({
      next: (response) => {
        console.log('Account updated successfully:', response);
        this.save.emit(); // Notify the parent component
      },
      error: (error) => {
        console.error('Error updating account:', error);
      },
    });
  }

  // Logout function to handle logout request
  logout() {
    this.accountService.logout(this.userAccount.email).subscribe({
      next: () => {
        console.log('Logged out successfully');
        this.router.navigate(['/login']); // Redirect to login page after logout
      },
      error: (error) => {
        console.error('Error logging out:', error);
      },
    });
  }
}
